import { ColumnCount } from './cus-product-list.data';

export const PRODUCT_LIST_MODULE_NAME = 'cus-product-list';

export const DEFAULT_MOBILE_COLUMN_COUNT: ColumnCount = 2;

export const FIRST_PAGE = 1;
export const PAGE_STEP = 1;
export const DECIMAL_RADIX = 10;

export const MAX_VISIBLE_PAGES_WITHOUT_ELLIPSIS = 7;
export const PAGINATION_EDGE_PAGE = 2;
export const PAGINATION_SIBLING_COUNT = 1;

export const PERCENT_MULTIPLIER = 100;
export const PRICE_RANGE_MIN_GAP = 1;

export const CATEGORY_NAV_DRAG_THRESHOLD_PX = 6;

export const PRODUCT_CARD_IMAGE_QUALITY = 100;

export const WISHLIST_NAME = 'Wishlist';
export const WISHLIST_COMMERCE_LIST_TYPE_VALUE = 1;
export const NEW_COMMERCE_LIST_ID = 0;

export const PRIORITY_IMAGE_COUNT = 4;
export const PENDING_WISHLIST_VARIANT_RECORD_ID_KEY = 'pending-wishlist-variant-record-id';

export const COLOR_HEX_MAP: Record<string, string> = {
    black: '#000000',
    white: '#ffffff',
    grey: '#9e9e9e',
    gray: '#9e9e9e',
    brown: '#8b4513',
    yellow: '#f5c518',
    blue: '#1d4ed8',
    purple: '#7e22ce',
    red: '#dc2626',
    pink: '#ec4899',
    green: '#16a34a',
    orange: '#f97316',
    beige: '#e3d3b3',
    navy: '#1e3a8a',
    silver: '#c0c0c0',
    gold: '#d4af37'
};
